<template>
  <div id="app" class="application" data-app v-scroll="onScrollHandler">
    <div class="application_wrap" v-resize="calcContentPadding">
      <header
        class="header"
        :style="{ height: `${application.top}px` }"
        ref="header"
      >
        <div class="header__wrap">
          <main-menu :items="mainMenu">
            <template v-slot:leftSide>
              <div class="socials">
                <div class="layout row">
                  <AppBtn
                    icon-only
                    target="_blank"
                    href="https://www.twitch.tv/redbullrus"
                  >
                    <SvgIcon size="20" name="twitch" />
                  </AppBtn>
                  <AppBtn
                    icon-only
                    target="_blank"
                    href="https://vk.com/redbullgaming"
                  >
                    <SvgIcon size="20" name="vk" />
                  </AppBtn>
                </div>
              </div>
            </template>
            <template v-slot:rightSide>
              <div class="auth d-flex align-center">
                <ContestProfileWidget
                  v-if="isContestPage"
                  class="hidden-xs-only"
                />
                <user-profile-widget v-else class="hidden-xs-only" />

                <app-drawer right content-class="drawer-content">
                  <template v-slot:activator="{ on }">
                    <AppBtn
                      icon-only
                      v-on="on"
                      class="hidden-md-and-up burger-btn"
                    >
                      <div class="burger">
                        <span
                          class="burger-bars"
                          v-for="(x, i) in 3"
                          :key="i"
                          :style="{ top: 20 * (i * 2) + '%' }"
                        ></span>
                      </div>
                    </AppBtn>
                  </template>

                  <template v-slot:default>
                    <template v-if="$app.breakpoint.xsOnly">
                      <ContestProfileWidget
                        v-if="isContestPage"
                        :status="false"
                      />
                      <user-profile-widget v-else :status="false" />
                      <div class="divider"></div>
                    </template>

                    <div class="menu__list">
                      <AppBtn
                        class="menu__item"
                        v-for="item in mainMenu"
                        :key="item.name"
                        :to="item.to"
                        :href="item.href"
                        :exact="item.exact"
                        :target="item.target"
                        :class="item.extraClass"
                        >{{ item.name }}</AppBtn
                      >
                    </div>
                  </template>
                </app-drawer>
              </div>
            </template>
          </main-menu>
        </div>
      </header>

      <app-content ref="content" :style="contentStyles">
        <div class="container fluid pa-0 grid-list-lg">
          <router-view />
        </div>
      </app-content>

      <footer
        class="footer"
        :style="{ height: `${application.bottom}px` }"
        ref="footer"
      >
        <div class="footer__wrap">
          <footer-menu v-show="needShowFooterPartners">
            <AppBtn
              class="partner-item"
              v-for="(item, i) in partners"
              :key="i"
              :href="item.link"
              target="_blank"
            >
              <img height="30" :src="item.logo_footer" :alt="item.name" />
            </AppBtn>
          </footer-menu>
          <!-- <bottom-menu :items="[]" /> -->
          <FooterRB />
        </div>
      </footer>
    </div>
    <app-modals />
    <ProtestedMatchesPopup />
    <StartedMatchPopup />
  </div>
</template>

<script>
import scroll from "@/core/directives/scroll";

import UserProfileWidget from "@/components/user/UserProfileWidget";
import ContestProfileWidget from "@/components/contest/user/ContestProfileWidget";
import AppContent from "@/components/ui/AppContent";
import AppModals from "@/components/ui/modal/Component";
import AppDrawer from "@/components/ui/menus/AppDrawer";
import MainMenu from "@/components/menus/MainMenu";
import FooterMenu from "@/components/menus/FooterMenu";
// import BottomMenu from "@/components/menus/BottomMenu";
import FooterRB from "@/components/menus/FooterRB";
import ProtestedMatchesPopup from "@/components/tournament/ProtestedMatchesPopup";
import StartedMatchPopup from "@/components/tournament/StartedMatchPopup";

import { mapState, mapGetters } from "vuex";

import showAlert from "@/services/common/showAlert";
import showNotify from "@/services/common/showNotify";
import showConfirm from "@/services/common/showConfirm";

window.showAlert = showAlert;
window.showNotify = showNotify;
window.showConfirm = showConfirm;

export default {
  components: {
    AppContent,
    AppDrawer,
    MainMenu,
    // BottomMenu,
    FooterMenu,
    AppModals,
    UserProfileWidget,
    ContestProfileWidget,
    FooterRB,

    ProtestedMatchesPopup,
    StartedMatchPopup
  },

  directives: { scroll },

  data: () => ({
    topMenu: [
      { name: "Видео", link: "https://www.redbull.com/int-en/discover" },
      { name: "События", link: "https://www.redbull.com/ru-ru/events" },
      { name: "Атлеты", link: "https://www.redbull.com/ru-ru/athletes" },
      { name: "Продукты", link: "https://www.redbull.com/ru-ru/energydrink" }
    ],

    mainMenu: [
      { name: "Главная", to: "/", exact: true },
      { name: "О турнире", to: "/#about" },
      // { name: "Карта", to: "/#map" },
      { name: "Квалификации", to: "/#qualifications" },
      { name: "Wildcards", to: "/#wildcards" },
      {
        name: "Как играть",
        to: "/how-to-play"
        // href: "https://www.redbull.com/ru-ru/red-bull-River-runes",
        // target: "_blank"
      },
      // {
      //   name: "Призы",
      //   href: "https://www.redbull.com/ru-ru/events/river-runes-2021/prizes",
      //   target: "_blank"
      // }
      { name: "Призы", to: "/prizes" }
      /* {
        name: "Конкурс",
        to: "/competition",
        extraClass: "prizes-btn"
        // target: "_blank"
      } */
    ],

    bottomMenu: [
      {
        name: "Положение о конфиденциальности",
        href: "https://www.redbull.com/pp/ru_RU",
        target: "_blank"
      },
      {
        name: "Условия использования",
        href: "https://www.redbull.com/tou/ru_RU",
        target: "_blank"
      },
      {
        name: "Продукты и компания",
        href: "http://energydrink-ru.redbull.com/",
        target: "_blank"
      },
      {
        name: "О компании",
        href: "https://www.redbull.com/im/ru_RU",
        target: "_blank"
      },
      {
        name: "Защита бренда",
        href: "https://www.redbull.com/bp/ru_RU",
        target: "_blank"
      },
      {
        name: "Медиа",
        href: "https://www.redbullcontentpool.com/",
        target: "_blank"
      },
      {
        name: "Связаться с нами",
        href: "http://energydrink-ru.redbull.com/red-bull-rossiya-kontakti",
        target: "_blank"
      },
      {
        name: "Онлайн магазин",
        href:
          "https://www.redbullshop.com/en/?utm_campaign=navi&amp;utm_source=redbull.com&amp;utm_medium=projects&amp;utm_content=en&amp;wt_mc=projects.redbull_com.navi",
        target: "_blank"
      },
      {
        name: "Работа в Red Bull",
        href: "http://jobs.redbull.com/ru/ru",
        target: "_blank"
      }
    ],

    application: {
      top: 0,
      bottom: 0
    },

    scrollTop: 0
  }),

  computed: {
    ...mapState("route", {
      hasHash: s => s.hash && s.hash.length > 0
    }),

    isContestPage() {
      return this.$route.name === "competition";
    },

    ...mapGetters("auth", ["isAuthenticated"]),

    partners() {
      return this.$store.getters.partners;
    },

    contentStyles() {
      return {
        paddingTop: `${this.application.top}px`,
        paddingBottom: `${this.application.bottom}px`
      };
    },

    needShowFooterPartners() {
      return this.$route.name !== "home";
    }
  },

  watch: {
    scrollTop(after, before) {
      if (after < before && after <= this.application.top && this.hasHash) {
        this.$router.replace(Object.assign({}, this.$route, { hash: "" }));
      }
    },
    needShowFooterPartners() {
      this.$nextTick(() => this.calcContentPadding());
    }
  },

  methods: {
    getChildHeight(list) {
      return Array(list.length)
        .fill(0)
        .map((n, i) => list[i].offsetHeight)
        .reduce((res, val) => res + val);
    },

    calcContentPadding() {
      this.application = {
        top: this.getChildHeight(this.$refs.header.children),
        bottom: this.getChildHeight(this.$refs.footer.children)
      };
    },

    onScrollHandler(e) {
      let el = e.target.scrollingElement;
      if (el && el.scrollTop >= 0) this.scrollTop = el.scrollTop;
    },

    openMenu() {
      this.$refs.menubar.openMenu();
    }
  },

  mounted() {
    this.calcContentPadding();
  }
};
</script>

<style lang="scss">
.menu__item.prizes-btn {
  .btn__content {
    color: #fbc33e;
    text-shadow: 0px 0px 20px #ff0000, 0px 0px 15px #ff0003;
  }
}

.partner-item {
  padding: 14px 16px;
}

.page-section {
  position: relative;
  width: 100%;
  margin-bottom: 30px;

  &:before {
    content: "";
    display: block;
    position: absolute;
    z-index: 2;

    width: 100%;
    height: 100%;

    left: 0;
    top: 0;
  }

  &.about_tournament,
  &.offline:not(.grand_final) {
    &:before {
      background: url("~@/assets/img/about-tournament-bg.png") no-repeat center;
      width: 1196px;
      height: 443px;
      left: 50%;
      top: 50%;
      margin-left: 1196px / 2 * -1;
      margin-top: 443px / 2 * -1;
    }
  }

  &__content {
    position: relative;
    z-index: 5;

    > .title {
      margin-bottom: 30px;
    }

    p {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 20px;
    }
  }

  &_card {
    border-radius: 6px;
    padding: 30px;
    background: gradient(#1e2135, #304d96, to bottom, 0.65, 0.65);

    @include breakpoint("xs-only") {
      padding: 15px;
    }
  }

  .title {
    font-size: 52px;

    @include breakpoint("xs-only") {
      font-size: 36px;
    }
  }

  @include breakpoint("xs-only") {
    &.qualifications {
      .title {
        font-size: 28px;
      }
    }
  }
}

.burger-btn {
  @include breakpoint("sm-and-down") {
    margin-right: 15px;
  }

  @media (max-width: 649px) {
    margin-right: 10px;
  }
}

.socials {
  @include breakpoint("sm-and-down") {
    margin-left: 20px;
  }
  @media (max-width: 649px) {
    margin-left: 10px;
  }
}

.page {
  background: url("~@/assets/img/rb-pattern.png") repeat;
  background-size: 100% auto;
  // mix-blend-mode: luminosity;
  // overflow-x: hidden;
}

.drawer-content {
  .user-profile-widget {
    padding: 0;

    .dropdown-menu,
    .dropdown-menu__activator {
      display: flex;
      flex-direction: row;
      max-width: 100%;
      flex: 1 1 100%;
    }

    .dropdown-menu__activator {
      padding: 12px 24px;
    }

    .user__info {
      flex: 1 1 100%;
    }
  }

  .menu__list {
    margin: -12px 0;
    display: flex;
    flex-direction: column;

    .menu__item {
      justify-content: flex-start;
      border-radius: 0px;

      padding: 12px 24px;
      margin: 0 -24px;
      flex: 1 1 100%;

      color: #fff;
      font-weight: 800;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      transition: $primary-transition;

      &:hover {
        background: rgba(#1e2135, 0.6);
      }

      &.btn_active {
        background: rgba(#1e2135, 0.8);
      }
    }
  }

  .divider {
    color: rgba(#fff, 0.2);
    padding: 0;
    margin: 12px 24px;
  }
}

.main-menu {
  .auth {
    min-height: 60px;

    .btn_orange-grad {
      &:not(:hover) {
        color: #ffc58f;
      }
    }
  }
}

.bottom-menu,
.top-menu {
  background: rgba(#1e2135, 0.4);

  &__list {
    text-align: center;

    .menu__item {
      font-size: 12px;
      display: inline-block;
      text-transform: uppercase;
      color: #5f6a7a;
      vertical-align: middle;
      font-weight: normal;

      &_link {
        transition: $primary-transition;

        cursor: pointer;
        &:hover {
          color: #fff;
        }
      }
    }
  }
}

.top-menu__list {
  .menu__item {
    line-height: 14px;
    padding: 8px 14px;
  }
}

.bottom-menu__list {
  .menu__item {
    line-height: 14px;
    padding: 0 5px;
  }
}

.main-menu {
  background: #000a25;
  min-height: 62px;
  // max-height: 62px;
  height: 100%;
  border-top: 2px solid rgba(#e72f31, 0.66);
  border-bottom: 2px solid rgba(#1480b2, 0.66);

  &__list {
    display: flex;
    justify-content: center;
    height: 100%;
    // max-width: 600px;
    // flex: 1 1 auto;
  }

  .menu__item {
    font-weight: 800;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #fff;
    padding: 20px 15px;
    cursor: pointer;
    text-transform: uppercase;
    transition: $primary-transition;

    @include breakpoint("md-only") {
      font-size: 13px;
      padding: 20px 10px;
    }

    &_text {
      text-align: center;
    }

    &:hover {
      background: rgba(#1e2135, 0.6);
    }

    &.active {
      background: rgba(#1e2135, 0.8);
    }
  }

  .socials .btn_icon_only {
    padding: 4px;
  }
}

.developed_by {
  display: inline-flex;
  align-items: center;

  img {
    margin-left: 8px;
  }
}

.bottom-menu {
  &__list {
    flex: 1 1 auto;

    flex: 0 0 auto;
    width: auto;
    max-width: 100%;

    // align-self: flex-start;

    &.order-2 {
      order: 1;
      flex: 1 1 100%;
      width: 100%;

      text-align: center;
      font-size: 12px;

      display: flex;
      min-width: 0;

      > * {
        flex: 0 0 auto;
        width: auto;
        margin: auto;
        max-width: 100%;
        white-space: nowrap;

        padding: 0 5px;
        line-height: 30px;

        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }

    &.order-1 {
      order: 2;
    }

    &.order-3 {
      order: 3;
      margin-left: auto;
    }

    &.order-1,
    &.order-3 {
      align-self: center;
      line-height: 35px;
    }
  }
}

@include breakpoint("md-and-down") {
  .bottom-menu {
    &__list {
      &.order-2 {
        order: 1;
        flex: 1 1 100%;
        flex-wrap: wrap;
        justify-content: center;

        > * {
          margin: 0 3px;
        }
      }

      &.order-1,
      &.order-3 {
        margin: 0;
        padding: 0 8px;
      }

      &.order-1 {
        margin-left: auto;
      }

      &.order-3 {
        margin-right: auto;
      }
    }
  }
}

@include breakpoint("xs-only") {
  .bottom-menu {
    &__list {
      &.order-1 {
        order: 2;
      }
      &.order-2 {
        order: 1;
      }
      &.order-3 {
        order: 3;
      }

      &.order-1,
      &.order-3 {
        margin-top: 14px;
        //   flex: 1 1 100%;
        //   width: 100%;
      }
    }
  }
}
</style>
